/* tslint:disable:indent */
import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {SharedModule} from '../../shared/shared.module';
import {EformsComponentComponent} from './components/eforms-component/eforms-component.component';
import {EFormsGeneratorComponent} from './components/e-forms-generator/e-forms-generator.component';
import {SectionComponent} from './components/section/section.component';
import {GroupComponent} from './components/group/group.component';
import {SubSectionComponent} from './components/sub-section/sub-section.component';
import {SubGroupComponent} from './components/sub-group/sub-group.component';
import {SubSubGroupComponent} from './components/sub-sub-group/sub-sub-group.component';
import {SubSubSubGroupComponent} from './components/sub-sub-sub-group/sub-sub-sub-group.component';
import { EformsContentTableComponent } from './components/eforms-content-table/eforms-content-table.component';
import {MatIconModule} from "@angular/material/icon";
import { MatTableModule } from '@angular/material/table';
import { TableModalComponent } from './components/generic/modals/table-modal/table-modal.component';
import { SubSubSubSubGroupComponent } from './components/sub-sub-sub-sub-group/sub-sub-sub-sub-group.component';
import { AccordionComponent } from './components/accordion/accordion.component';
import { ActionFieldComponent } from './components/accordion/action-field/action-field.component';
import { DuplicableElementComponent } from './components/duplicable-element/duplicable-element/duplicable-element.component';
import {MatTooltipModule} from "@angular/material/tooltip";


@NgModule({
  declarations: [
    EformsComponentComponent,
    EFormsGeneratorComponent,
    SectionComponent,
    GroupComponent,
    SubSectionComponent,
    SubGroupComponent,
    SubSubGroupComponent,
    SubSubSubGroupComponent,
    EformsContentTableComponent,
    TableModalComponent,
    SubSubSubSubGroupComponent,
    AccordionComponent,
    ActionFieldComponent,
    DuplicableElementComponent],
  exports: [EformsComponentComponent],
    imports: [CommonModule, MatTableModule, ReactiveFormsModule, SharedModule, FormsModule, MatIconModule, MatTooltipModule],
})
export class EformsModule {
}
